import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useCarousels(env, client) {
  const [loadedCarousels, setLoadedCarousels] = useState(false);
  const [carousels, setCarousels] = useState(null);

  useEffect(() => {
    setLoadedCarousels(false);
    if (!client) {
      setLoadedCarousels(true);
      return () => [];
    }
    const ref = collection(db, "kiosk", env, "client", client, "promo-groups");

    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = {};

      snapshot.docs.forEach((doc) => {
        data[doc.id] = {
          id: doc.id,
          ...doc.data()
        };
      });

      setCarousels(data);
      setLoadedCarousels(true);
    });

    return () => unsub();
  }, [env, client]);

  return { loadedCarousels, carousels };
}